import type { FaireProductEntity } from "../../entity_types/product";

export const p_7nq3xv8mpc: FaireProductEntity = {
  token: "p_7nq3xv8mpc",
  type: "product",
  name: "STRIPED RUFFLE DETAIL MIDI DRESS WITH POCKETS / WL25-12463",
  brandToken: "b_1hsvo6fo88",
  brandName: "Wishlist Apparel",
  imageUrl:
    "https://cdn.faire.com/fastly/db9315cdee92fd5c85a37f83cce1e5b04602d84bca97638dd947bbd48a3a8f8b.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/4821b02f51be8a0517a6306ea70930bb7bf8e371674c7ee03b8b600639bb7717.jpeg",
    "https://cdn.faire.com/fastly/cf86675ae8d3f40c73acd1d21c19a1b9afc3d670a5ccca7512a5a5de6e6f6b6c.jpeg",
    "https://cdn.faire.com/fastly/3a17ed9985a6a70603f6f8ab3464fc47dbd7a9c4a3e0895b6fc4553840f3c499.jpeg",
    "https://cdn.faire.com/fastly/6effbb289a8a19b6a163bea39903f6c170fed98076268452d554140bcfbc9feb.jpeg",
    "https://cdn.faire.com/fastly/b3896f13125d601738864090aa2b55649cd3b20af1524663fe1583931603587c.jpeg",
    "https://cdn.faire.com/fastly/c4e0947bfe6b47d0a1e8b9c152c2c581b751b587496b51c2fe89539c59d14902.jpeg",
    "https://cdn.faire.com/fastly/8a5f732cb3323245e02ee964516279a0b2d1ba27e66aa63294a7bc19c3688e0c.jpeg",
  ],
  priceDollars: 235.5,
  description:
    'STY# WL25-12463\n\n- STRIPED DESIGN\n- MIDI LENGTH\n- SQUARE NECK\n- RUFFLE DETAIL\n- SELF BACK TIE\n- SIDE POCKETS\n- LINED\n\nMODEL IS WEARING SIZE S.\nSMALL: TOTAL LENGTH - 49 1/2"\n\nSELF: 100% COTTON\nLINING: 100% RAYON\n\n\n* Due to lighting and differences in monitors, actual colors may vary slightly from what appears online.',
  tags: [],
  msrpDollars: 471,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T06:20:04.183Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
